import dayjs from "dayjs";
export function hasActiveSubscription(company) {
    var _a, _b;
    return (((_b = (_a = company === null || company === void 0 ? void 0 : company.subscriptions) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.expiryDate) !== undefined && company.subscriptions.current.expiryDate > (new Date()).toISOString());
}
export function subscriptionDaysRemaining(company) {
    var _a, _b;
    if (!((_b = (_a = company === null || company === void 0 ? void 0 : company.subscriptions) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.expiryDate)) {
        return 0;
    }
    return dayjs(company.subscriptions.current.expiryDate).diff(dayjs(), 'day') + 1;
}
